// import React from "react";
// import ReactDOM from "react-dom/client";
// import "./index.css";
// import App from "./App";
// import reportWebVitals from "./reportWebVitals";
// import { Provider } from "react-redux";
// import { createStore } from "redux";
// import { crmreducer } from "./Store/Reducer";

// const store = createStore(crmreducer);

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <Provider store={store}>
//     <React.StrictMode>
//       <App />
//     </React.StrictMode>
//   </Provider>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { createStore } from "redux";
import rootReducer from "./Store"; // Assuming index.js in Store folder exports rootReducer

import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
// import WrappedApp from "./App";

const store = createStore(rootReducer);

ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
      <App />
      {/* <WrappedApp/> */}
    </React.StrictMode>
  </Provider>,
  document.getElementById("root")
);

reportWebVitals();
